import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// import "promise-polyfill/src/polyfill";
import i18n from "@/plugins/i18n";
import ValidationPlugin from "@/plugins/validationPlugin";
import Vue3Lottie from "vue3-lottie";

const app = createApp(App);
app.use(store);
app.use(router);
app.use(i18n);
app.use(Vue3Lottie, { name: "LottieAnimation" });
app.use(ValidationPlugin);

app.mount("#app");
